import { createContext } from 'react';
export const BlockNumbersContext = createContext({});
//# sourceMappingURL=context.js.map